<p-dialog
  *ngIf="showMoreInfoDialog"
  [visible]="showMoreInfoDialog"
  (visibleChange)="onFlag('showMoreInfoDialog', $event)"
  [blockScroll]="true"
  [dismissableMask]="true"
  [draggable]="false"
  [header]="'About Me'"
  [modal]="true"
  [position]="
    isMobile && isPortraitMode
      ? 'bottom'
      : isMobile && !isPortraitMode
        ? 'top'
        : 'center'
  "
  [style]="{
    minWidth: isMobile && !isPortraitMode ? '320px' : '370px',
    maxWidth: isMobile && !isPortraitMode ? '826px' : '500px',
    height: !isEmbedded && isMobile && !isPortraitMode ? '100vh' : 'unset'
  }"
  class="dialog more-info-dialog"
  styleClass="more-info-dialog"
  appendTo="body">
  <div class="more-info-body">
    <div
      *ngIf="currentPitchCardType !== 'resume'"
      class="working-hours-container">
      <span *ngFor="let row of moreInfoWorkingHours" class="working-hours-row">
        <span *ngFor="let range of row.workingDays; let last = last">
          {{ range }}{{ range.length > 1 && !last ? ', ' : ' : ' }}
        </span>
        <span> {{ row.openHours }} - {{ row.closeHours }} </span>
      </span>
    </div>
    <div
      #socialLinks
      [style.justifyContent]="
        socialLinks.childElementCount < 6 ? 'space-around' : 'space-between'
      "
      class="social-icons-container">
      <div *ngIf="currentPitchCard?.websiteLink" class="item-icon">
        <a
          [href]="validateLink(currentPitchCard?.websiteLink)"
          [ngClass]="{ empty: !currentPitchCard?.websiteLink }"
          rel="noopener noreferrer"
          target="_blank">
          <img
            alt="Web icon"
            src="assets/images/pitch-card-svg/resume/web-icon.svg" />
        </a>
        <div class="icon-title">Website</div>
      </div>
      <div *ngIf="currentPitchCard?.calendarLink" class="item-icon">
        <a
          [href]="validateLink(currentPitchCard?.calendarLink)"
          [ngClass]="{ empty: !currentPitchCard?.calendarLink }"
          target="_blank">
          <img alt="Calendar icon" src="assets/images/calendar-icon.svg" />
        </a>
        <div class="icon-title">Calendar</div>
      </div>
      <div *ngIf="currentPitchCard?.facebookLink" class="item-icon">
        <a
          [href]="validateLink(currentPitchCard?.facebookLink)"
          [ngClass]="{ empty: !currentPitchCard?.facebookLink }"
          rel="noopener noreferrer"
          target="_blank">
          <img
            alt="Facebook icon"
            src="assets/images/pitch-card-svg/resume/facebook-icon.svg" />
        </a>
        <div class="icon-title">Facebook</div>
      </div>
      <div *ngIf="currentPitchCard?.twitterLink" class="item-icon">
        <a
          [href]="validateLink(currentPitchCard?.twitterLink)"
          [ngClass]="{ empty: !currentPitchCard?.twitterLink }"
          rel="noopener noreferrer"
          target="_blank">
          <img
            alt="Twitter icon"
            src="assets/images/pitch-card-svg/resume/twitter-icon.svg" />
        </a>
        <div class="icon-title">Twitter</div>
      </div>
      <div *ngIf="currentPitchCard?.instagramLink" class="item-icon">
        <a
          [href]="validateLink(currentPitchCard?.instagramLink)"
          [ngClass]="{ empty: !currentPitchCard?.instagramLink }"
          rel="noopener noreferrer"
          target="_blank">
          <img
            alt="Instagram icon"
            src="assets/images/pitch-card-svg/resume/instagram-icon.svg" />
        </a>
        <div class="icon-title">Instagram</div>
      </div>
      <div *ngIf="currentPitchCard?.linkedinLink" class="item-icon">
        <a
          [href]="validateLink(currentPitchCard?.linkedinLink)"
          [ngClass]="{ empty: !currentPitchCard?.linkedinLink }"
          rel="noopener noreferrer"
          target="_blank">
          <img
            alt="Linkedin icon"
            src="assets/images/pitch-card-svg/resume/linkedin-icon.svg" />
        </a>
        <div class="icon-title">Linkedin</div>
      </div>
      <div *ngIf="currentPitchCard?.pinterestLink" class="item-icon">
        <a
          [href]="validateLink(currentPitchCard?.pinterestLink)"
          [ngClass]="{ empty: !currentPitchCard?.pinterestLink }"
          rel="noopener noreferrer"
          target="_blank">
          <img
            alt="Pinterest icon"
            src="assets/images/pitch-card-svg/resume/pinterest-icon.svg" />
        </a>
        <div class="icon-title">Pinterest</div>
      </div>
    </div>
    <div
      [ngClass]="{ hidden: !currentPitchCard.pricingModel }"
      class="descriptions">
      <div class="textarea-template w-12">
        <div [id]="'e_description_' + uniqueId" class="editor-preview"></div>
      </div>
    </div>
  </div>
</p-dialog>
